'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = msToReadableString;
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Returns a time formatted string of HH:MM:SS when provided with a milliseconds value.
 * @providesModule msToReadableString
 */

function prependZeroAsNecessary(value) {
  var hideZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value < 10 && !hideZero) {
    return '0' + value;
  }
  return value;
}

function msToReadableString(milliseconds, shouldIncludeMs) {
  var value = milliseconds / 1000;

  var t = Math.round(value);
  var timeCheck = t;
  var hours = Math.floor(t / 3600);
  t %= 3600;

  var minutes = Math.floor(t / 60);
  var seconds = t % 60;
  var ms = seconds % 60;

  hours = prependZeroAsNecessary(hours, timeCheck > 3600);
  minutes = prependZeroAsNecessary(minutes, timeCheck === 0 || Math.floor(timeCheck / 60) < 10);
  seconds = prependZeroAsNecessary(seconds);
  ms = prependZeroAsNecessary(ms);

  return (hours === '0' || hours === '00' || minutes < 60 && hours < 1 ? '' : hours + ':') + (minutes + ':') + seconds + (shouldIncludeMs ? ':' + ms : '');
}
module.exports = exports['default'];